import {configureStore}  from '@reduxjs/toolkit';
import userReducer from './Slices/userSlice';
import commonReducer from '../src/Slices/commonSlice';
export const store= configureStore({
reducer:{
    userDetail:userReducer,
    commonState:commonReducer
}

})